import { alpha, Stack, Typography, useTheme } from "@mui/material";
import { Star } from "lucide-react";
import type { FC, ReactNode } from "react";

type Props = {
	accent: string;
	label: string;
	children: ReactNode;
};

export const WhatIfExpandedCard: FC<Props> = ({ accent, label, children }) => {
	const theme = useTheme();

	return (
		<Stack
			p={1.2}
			border={theme.colors.border.solid(alpha(accent, 0.2))}
			borderRadius={theme.radii.xl}
			bgcolor={alpha(accent, 0.04)}
		>
			<Stack direction="row" alignItems="center" gap={0.6}>
				<Star size={14} color={accent} fill={accent} />
				<Typography
					variant="caption"
					fontWeight={600}
					color={accent}
					textTransform="uppercase"
					letterSpacing={0.5}
				>
					{label}
				</Typography>
			</Stack>
			{children}
		</Stack>
	);
};
